<app-change-control-target-completion-date-modal
  *ngIf="showTargetCompletionDateModal"
  [targetCompletionDateForCC]="changeControlDetails.targetCompletionDate"
  (targetCompletionDateToSave)="updateTargetCompletionDate($event)"
  (closeTargetCompletionDateModal)="closeTargetCompletionDateModal($event)"
>
</app-change-control-target-completion-date-modal>
<p-dialog
  [(visible)]="display"
  [style]="{ width: '95vw' }"
  (onHide)="closeTransactionModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <app-read-only
      readonlyText="{{ changeControlTransactionLabels.header }}"
    ></app-read-only>
  </ng-template>
  <div id="changeControl-{{ changeControlTransactionLabels.header }}">
    <app-panel-list
      *ngIf="!showLoader"
      [panelList]="panelListData"
      [noResultFound]="!isDataAvailable"
    >
      <ng-template #templateRef let-data="dataVar">
        <div panel-content>
          <div class="grid">
            <div class="col-10">
              <div class="grid">
                <div class="col-6 text-left">
                  <app-label
                    labelText="{{ changeControlTransactionLabels.userName }}"
                  ></app-label>
                  <app-read-only
                    readonlyText="{{ data?.name }}"
                  ></app-read-only>
                </div>
                <div class="col-3 text-left">
                  <app-label
                    labelText="{{ changeControlTransactionLabels.status }}"
                  ></app-label>
                  <div class="grid">
                    <div class="col max-w-0">
                      <em
                        class="pi pi-circle-fill"
                        [ngClass]="{
                          pending: data?.status == 0,
                          completed: data?.status == 1
                        }"
                      ></em>
                    </div>
                    <div class="col ml-1">
                      <app-read-only
                        readonlyText="{{ data?.statusName }}"
                      ></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="col-3 text-left">
                  <app-label
                    labelText="{{ changeControlTransactionLabels.date }}"
                  ></app-label>
                  <app-read-only
                    readonlyText="{{ data?.date | date : 'dd-MMM-yyyy' }}"
                  ></app-read-only>
                </div>
              </div>
            </div>
            <div
              class="col-2 text-left m-auto"
              *ngIf="data?.isCompleteButtonAvailable"
            >
              <p-button
                appPreventDoubleClick
                label="Complete"
                icon="fas fa-check"
                id="reviewStatusButton"
                iconPos="left"
                (debounceClick)="updateStatus(data)"
              ></p-button>
            </div>
          </div>
        </div>
      </ng-template>
    </app-panel-list>
  </div>
</p-dialog>
<p-dialog
  [(visible)]="showEsignatureConfirmationDialog"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ confirmationMessage }}</span>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="No"
      type="submit"
      icon="pi pi-times"
      id="closeEsignature"
      styleClass="p-button-outlined"
      class="align-right"
      (onClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="saveEsignature"
      class="align-right"
      (onClick)="onConfirm()"
    >
    </p-button>    
  </ng-template>
</p-dialog>

